import { useFeatureFlagsStore } from '../stores/featureFlagsStore'

/**
 * Whether a feature is enabled for the current account. Unknown keys fall back
 * to `fallback` (default false) so a typo hides the feature rather than leaking
 * it. Re-renders when the resolved flag changes.
 *
 *   const showBoomerang = useFeatureFlag('boomerang')
 */
export function useFeatureFlag(key: string, fallback = false): boolean {
  return useFeatureFlagsStore((s) => (key in s.flags ? Boolean(s.flags[key]) : fallback))
}
